import
  React
from 'react';

import {
  Spinner,
} from 'ui/common/components';

export const withLazy = (
  dynamicImport,
  componentName,
) => {

  return class WithLazyLoad extends React.Component {

    state = {
      component: null
    };

    unmounted = false;

    componentDidMount = () => {

      if (!dynamicImport) {
        return;
      }

      dynamicImport
        .then(module => {

          !this.unmounted && this.setState({
            component: module[componentName]
          });
        })
        .catch(e => console.error(e));
    };

    componentWillUnmount = () => {
      this.unmounted = true;
    };

    render = () => {

      const ImportedComponent = this.state.component;

      return !!ImportedComponent

        ? <ImportedComponent {...this.props}/>
        : <Spinner/>
    };
  };
};
